export default {  
  setUser(state, payload) {
  	if(!payload){
  		payload = {};
  	}
    state.user = payload;
  },  
};